<template>
    <div class="modal-editElderlyClass">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑老人分类</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">类型</div>
                        <el-input v-model="edit_Name" placeholder="请输入类型" ></el-input>
                    </el-col>

                    <el-col :span="12" class="item">
                        <div class="label">排序</div>
                        <el-input v-model="edit_sort" placeholder="请输入排序" ></el-input>
                    </el-col>
<!--                    <el-col :span="12" class="item">-->
<!--                        <div class="label">选择角色</div>-->
<!--                        <el-select v-model="edit_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">-->
<!--                            <el-option-->
<!--                                    v-for="item in roleList"-->
<!--                                    :key="item.roleCode"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.roleCode">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-col>-->

                </el-row>

                <el-row class="row">
<!--                    <el-col :span="12" class="item">-->
<!--                        <div class="label">姓名</div>-->
<!--                        <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>-->
<!--                    </el-col>-->
                    <el-col :span="12" class="item">
                        <div class="label">该类型充值金额</div>
                        <el-input v-model="edit_addBalance" placeholder="请输入手机"></el-input>
                    </el-col>

                    <el-col :span="12" class="item">
                        <div class="label">选择政府</div>
                        <el-select v-model="edit_governmentCode" @change="changeGovernment" style="width:100%">
                            <el-option
                                    v-for="item in governmentList"
                                    :key="item.governmentCode"
                                    :label="item.name"
                                    :value="item.governmentCode">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

<!--                <el-row class="row">-->
<!--                    <el-col :span="12" class="item">-->
<!--                        <div class="label">职工状态</div>-->
<!--                        <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="margin-right: 20px">-->
<!--                            <el-option-->
<!--                                    v-for="item in status2"-->
<!--                                    :key="item.value"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12" class="item">-->
<!--                        <div class="label">选择政府</div>-->
<!--                        <el-select v-model="edit_governmentCode" @change="changeGovernment" style="width:100%">-->
<!--                            <el-option-->
<!--                                    v-for="item in governmentList"-->
<!--                                    :key="item.governmentCode"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.governmentCode">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-col>-->

<!--                </el-row>-->


            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: [],
        data() {
            return {

                loading: false,

                edit_Name:'',
                edit_sort:'',
                edit_addBalance:'',
                edit_governmentCode:'',

                elderlyClassCode:'',
                // roleList:null,
                governmentList:null,
                //
                // status2: [{
                //     value: 0,
                //     label: '正常'
                // }, {
                //     value: 1,
                //     label: '被禁用'
                // }],
                // edit_status: 0,


            }
        },
        methods: {
            init(row){
                console.log("Edit init");
                console.log(row);
                this.edit_Name = row.name;
                this.edit_sort = row.sort;
                this.edit_addBalance = row.addBalance;
                this.edit_governmentCode = row.governmentCode;
                this.elderlyClassCode=row.elderlyClassCode;
                // this.getRoleList();
                this.getGovernmentList();

            },

            closeSelf() {
                this.loading= false
                this.$emit("closeEdit");
            },

            confirm(){


                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }


                if(this.edit_Name === ''){
                    this.loading = false;
                    return;
                }
                if(this.edit_sort === ''){
                    this.loading = false;
                    return;
                }
                if(this.edit_addBalance === ''){
                    this.loading = false;
                    return;
                }


                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'ElderlyClass/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name: this.edit_Name,
                        sort:this.edit_sort,
                        addBalance:this.edit_addBalance,
                        elderlyClassCode:this.elderlyClassCode,
                        governmentCode:this.edit_governmentCode,
                    }
                }).then( (response)=> {
                    console.log("1-------")
                    console.log(response)
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                        this.$message('修改成功！');
                    }else{
                        console.log("2-------")
                        console.log(response.data.message)
                        this.$message(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },


            // changeRole:function(selVal){
            //     this.edit_roleCode = selVal;
            // },
            changeGovernment:function(selVal){
                this.edit_governmentCode = selVal;
            },
            changeStatus:function (selVal) {
                this.edit_status = selVal;
            },
            getGovernmentList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Government/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    console.log("1------")
                    console.log(response.data);
                    if(response.data.error == 0){
                        this.governmentList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>


<style  lang="scss" scoped >
    .modal-editElderlyClass {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 500px;


            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
                overflow-y: auto;
            }
        }

    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
